import React from "react";
import { useNavigate } from "react-router-dom";

import FucaScoreLogo from "../../Assets/Images/fucascore_png.png";

const FSHomeJoin = () => {
  const navigate = useNavigate();

  const benefits = [
    {
      icon: "fi-rr-devices",
      title: "Vaša stranica turnira",
      text: "Vlastita FucaScore stranica koju dijelite ekipama i gledateljima.",
    },
    {
      icon: "fi-rr-live-alt",
      title: "Sve uživo",
      text: "Rezultati, događaji, tablice i statistika dostupni su u stvarnom vremenu.",
    },
    {
      icon: "fi-rr-settings-sliders",
      title: "Vi imate kontrolu",
      text: "Sami upravljate ekipama, rasporedom, rezultatima i sadržajem turnira.",
    },
  ];

  const features = [
    "Live rezultati i događaji",
    "Digitalni semafor",
    "Raspored po danima",
    "Tablice i završnica",
    "Strijelci i najbolji igrači",
    "Glasanje za igrača utakmice",
    "Sastavi momčadi",
    "Nagrade i priznanja",
    "Sponzori s linkovima",
    "Dodatni sadržaj turnira",
  ];

  return (
    <section className="fshome-join-section">
      <div className="join-glass-card">
        {/* LOGO */}
        <img className="logo" src={FucaScoreLogo} alt="FucaScore" />

        {/* BADGE */}
        <div className="join-badge">
          <i className="fa-solid fa-trophy"></i>
          <span>ZA ORGANIZATORE TURNIRA</span>
        </div>

        {/* NASLOV */}
        <h2 className="join-title">
          Vaš turnir.
          <br />
          <span>Vaša digitalna platforma.</span>
        </h2>

        {/* UVOD */}
        <p className="join-description">
          FucaScore pretvara vaš turnir u moderno digitalno iskustvo.
          Organizator dobiva vlastitu stranicu turnira, a igrači i gledatelji
          sve važne informacije na jednom mjestu.
        </p>

        {/* GLAVNA PORUKA */}
        <div className="join-main-message">
          <div className="message-icon">
            <i className="fi fi-br-link-alt"></i>
          </div>

          <div className="message-content">
            <strong>Jedan link. Cijeli turnir.</strong>

            <span>
              Vaš turnir dobiva vlastitu FucaScore stranicu, primjerice{" "}
              <b>fucascore.com/vas-turnir</b>, koju možete jednostavno
              podijeliti ekipama i gledateljima.
            </span>
          </div>
        </div>

        {/* BENEFITS */}
        <div className="join-benefits">
          {benefits.map((benefit, index) => (
            <div className="benefit-card" key={index}>
              <div className="benefit-icon">
                <i className={benefit.icon}></i>
              </div>

              <div className="benefit-content">
                <h3>{benefit.title}</h3>
                <p>{benefit.text}</p>
              </div>
            </div>
          ))}
        </div>

        {/* FEATURE NASLOV */}
        <div className="features-heading">
          <span></span>
          <p>SVE ŠTO VAŠ TURNIR TREBA</p>
          <span></span>
        </div>

        {/* FEATURES */}
        <div className="join-features-grid">
          {features.map((feature, index) => (
            <div className="feature-item" key={index}>
              <div className="feature-check-icon">
                <i className="fi fi-rs-check"></i>
              </div>

              <span>{feature}</span>
            </div>
          ))}
        </div>

        {/* ADMIN PORUKA */}
        <div className="join-admin-box">
          <div className="admin-icon">
            <i className="fi fi-rs-user-skill-gear"></i>
          </div>

          <div className="admin-content">
            <strong>Vi vodite turnir. FucaScore radi za vas.</strong>

            <span>
              Jednostavno administracijsko sučelje omogućuje vam da sami unosite
              i uređujete sve podatke turnira.
            </span>
          </div>
        </div>

        {/* RECENZIJA */}
        <div className="join-testimonial">
          <div className="testimonial-top">
            <div className="testimonial-stars">★★★★★</div>

            <span>STENJEVEC CUP</span>
          </div>

          <p className="testimonial-text">
            „Aplikacija nam je bila super za korištenje! Sve je pregledno,
            jednostavno i brzo, a posebno nam se svidjelo što su rezultati,
            raspored i ostale informacije dostupni na jednom mjestu. Sve je
            funkcioniralo bez problema i stvarno nam je olakšalo praćenje
            turnira. Sve pohvale!”
          </p>

          <div className="testimonial-author">
            <i className="fa-solid fa-circle-check"></i>
            <span>Stenjevec CUP</span>
          </div>
        </div>

        {/* PRICE */}
        {/*      <div className="join-price">
          <span className="price-label">KORIŠTENJE ZA JEDAN TURNIR</span>

          <div className="price-value">
            <strong>79 €</strong>
          </div>

          <span className="price-note">
            Jednokratno • Bez pretplate • Bez ugovora
          </span>
        </div> */}

        {/* CTA */}
        <div className="join-actions">
          <button
            className="join-btn primary-glow"
            onClick={() => navigate("/pokreni-turnir")}
          >
            <i className="fa-solid fa-rocket"></i>

            <span>Pokrenite svoj turnir</span>
          </button>

          <a
            href="https://www.instagram.com/fucascore/"
            target="_blank"
            rel="noreferrer"
            className="join-btn secondary-social"
          >
            <i className="fi fi-brands-instagram"></i>

            <span>Pogledajte FucaScore</span>
          </a>
        </div>

        {/* BOTTOM NOTE */}
        <div className="join-bottom-note">
          <div>
            <i className="fa-solid fa-check"></i>
            <span>Jednostavno za organizatora</span>
          </div>

          <div>
            <i className="fa-solid fa-check"></i>
            <span>Moderno za gledatelje</span>
          </div>

          <div>
            <i className="fa-solid fa-check"></i>
            <span>Profesionalno za turnir</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FSHomeJoin;
